"use strict";

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepare = void 0;

var SerializationState = function SerializationState(data) {
  var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  _classCallCheck(this, SerializationState);

  this.data = data;
  this.position = position;
};

exports.default = SerializationState;

function prepare(data) {
  return new SerializationState(data, 0);
}

exports.prepare = prepare;